/*
 *   File : manage-basket.js
 *   Author : https://evoqins.com
 *   Description : Manage basket page
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

// custom components
import { CustomSelectBox, CustomTextArea, CustomTextInput, FileSelector } from '../../Components/FormElements';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { APIService, AWSService } from '../../Service';
import { CreateUserGroup, PreviewModal, SuccessModal } from '../../Components/Modal';

// custom styles
import color from '../../Style/color.scss';

const TARGET_USERS_DATA = [
    {
        id: 1,
        label: 'All users',
        value: 'All users',
    },
    {
        id: 2,
        label: 'Invested users',
        value: 'Invested users',
    },
    {
        id: 3,
        label: 'Non-invested users',
        value: 'Non-invested users'
    },
    {
        id: 4,
        label: 'Signed up users',
        value: 'Signed up users'
    },
    {
        id: 5,
        label: 'Test users',
        value: 'Test users'
    }
];

const CreatePushNotification = () => {

    const hasFetchedRef = useRef(false);

    const navigate = useNavigate();
    const FILE_TYPES = ["PNG"];
    const inputRef = useRef({});

    const [notificationTitleName, setNotificationTitleName] = useState("");
    const [notificationTitleNameError, setNotificationTitleNameError] = useState("");
    const [notificationContent, setNotificationContent] = useState("");
    const [notificationContentError, setNotificationContentError] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);

    const [selectedOptionError, setSelectedOptionError] = useState("");
    const [pushNotificationModal, setPushNotificationModal] = useState(false);
    const [file, setFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState("");
    const [logo, setLogo] = useState(null);
    const [logoError, setSelectedLogoError] = useState("");
    const [notificationSend, setNotificationSend] = useState({});
    const [fileLoader, setFileLoader] = useState(false);
    const [logoLoader, setLogoLoader] = useState(false);

    const [createGroupModal, setCreateGroupModal] = useState(false);
    const [createGroupSuccess, setCreateGroupSuccess] = useState(false);
    const [sendStatus, setSendStatus] = useState(false);

    const [linkOptions, setLinkOptions] = useState([]);
    const [linkOptionLoader, setLinkOptionLoader] = useState(false);

    const [selectedRedirectionLink, setSelectedRedirectionLink] = useState(null);
    const [selectedRedirectionLinkError, setSelectedRedirectionLinkError] = useState("");


    // useEffect(() => {
    //     if (isRendered.current === true) {
    //         _sendNotification();
    //     }
    //     isRendered.current = false;
    // }, []);
    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (hasFetchedRef.current) return;

        hasFetchedRef.current = true;
        _listGroup();

        _getLinkOptions();
        setLinkOptionLoader(true);
    }, []);

    useEffect(() => {
        setNotificationTitleNameError("");
    }, [notificationTitleName]);

    useEffect(() => {
        setNotificationContentError("");
    }, [notificationContent]);

    useEffect(() => {
        setSelectedOptionError("");
    }, [selectedOption])

    useEffect(() => {
        setSelectedFileError("");
    }, [file])

    useEffect(() => {
        setSelectedLogoError("");
    }, [logo])

    useEffect(() => {
        setSelectedRedirectionLinkError("");
    }, [selectedRedirectionLink]);

    useEffect(() => {
        if (pushNotificationModal === true) {
            const push_notification_modal = new Modal(document.getElementById('preview-modal'));
            push_notification_modal.show();
        }
    }, [pushNotificationModal]);

    useEffect(() => {
        if (createGroupModal === true) {
            const modal = new Modal(document.getElementById("create-group-modal"));
            modal.show();
        }
    }, [createGroupModal]);

    useEffect(() => {
        if (createGroupSuccess === true) {
            const modal = new Modal(document.getElementById("success-modal"));
            modal.show();
        }
    }, [createGroupSuccess]);

    // handle change
    const _handleChange = (file) => {
        // const preview = URL.createObjectURL(file);
        // setFile(preview);
        _getPresignedUrl(file);
    };

    // handle change logo
    const _handleChangeLogo = (file) => {
        // const preview = URL.createObjectURL(file);
        // setLogo(preview);
        _getPresignedUrlLogo(file);
    };

    // handle close
    const _handleClose = (type) => {
        if (type === 1) {
            setFile(null);
        } else {
            setLogo(null);
        }
    };

    // handle cancel
    const _handleCancel = () => {
        navigate('/push-notification')
    };

    // handle focus error
    const _handleFocusError = (key) => {
        setTimeout(() => {
            if (inputRef.current[key]) {
                inputRef.current[key].scrollIntoView({
                    behavior: 'smooth',
                    top: 0
                });
                inputRef.current[key].focus();
            }
        }, 100);
    };

    // handle notification
    const _handleNotification = () => {
        let is_valid = true;
        let firstErrorKey = null;

        if (notificationTitleName.trim().length === 0) {
            setNotificationTitleNameError("Enter your notification title");
            is_valid = false;
            if (!firstErrorKey) firstErrorKey = 'notificationTitleName';
        }

        if (notificationContent.trim().length === 0) {
            setNotificationContentError('Enter your notification  content')
            is_valid = false;
            if (!firstErrorKey) firstErrorKey = 'notificationContent';
        }

        if (selectedOption === null) {
            setSelectedOptionError("Please select targeted user");
            is_valid = false;
            if (!firstErrorKey) firstErrorKey = 'selectedOption';
        }

        if (selectedRedirectionLink === null) {
            setSelectedRedirectionLinkError("Please select redirection link");
            is_valid = false;
            if (!firstErrorKey) firstErrorKey = 'selectedRedirectionLink';
        }

        // if (file === null) {
        //     setSelectedFileError("please select a file");
        //     is_valid = false;
        //     if (!firstErrorKey) firstErrorKey = 'file';
        // }

        // if (logo === null) {
        //     setSelectedLogoError("please select logo");
        //     is_valid = false;
        //     if (!firstErrorKey) firstErrorKey = 'logo';
        // }
        if (!is_valid && firstErrorKey) {
            _handleFocusError(firstErrorKey);
            return;
        }

        setPushNotificationModal(true);

    };

    // handle create group 
    const _handleCreateGroup = () => {
        setCreateGroupModal(true);
    };

    // handle continue to create group 
    const _handleContinue = (name) => {
        navigate("/customers", {
            state: {
                tab_index: 1,
                type: 'invested',
                group_name: name,
                path: "/push-notification/manage"
            }
        });
    };

    // API - Get link options
    const _getLinkOptions = () => {
        let is_post = false;
        let url = 'banner/filter-data';
        let request = {}

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setLinkOptions(response.data?.redirect ?? []);

                setSelectedRedirectionLink(response.data?.redirect[0] ?? null);
            } else {
                setLinkOptions([]);
            }
            setLinkOptionLoader(false);
        })
    };

    // Get - presigned url
    async function _getPresignedUrl(file) {

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        setFileLoader(true);

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setFile(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setFileLoader(false);

    };


    // Get - presigned url
    async function _getPresignedUrlLogo(file) {

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        setLogoLoader(true);

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setLogo(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setLogoLoader(false);

    };



    // API - send notification
    const _sendNotification = () => {
        let is_post = true;
        let url = 'notification/create';
        let request = {
            "title": notificationTitleName,
            "description": notificationContent,
            "banner_image": file,
            "image": logo,
            "notification_type": selectedOption?.value || null,
            "deeplink": selectedRedirectionLink?.value || null
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSendStatus(true);
                setNotificationSend(response.data)
                // setPushNotificationModal(false);

                setTimeout(() => {
                    navigate('/push-notification');
                    toast.success("Notification created", { type: "success" });
                }, 200);


                setFile(null);
                setLogo(null);
                setNotificationContent("");
                setNotificationTitleName("");
                setSelectedOption(null);
                setSelectedRedirectionLink(linkOptions[0]);
            } else {
                setSendStatus(false);

                setNotificationSend({});
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }

        })
    };

    const [userGroupLoader, setUserGroupLoader] = useState(true);
    const [groupList, setGroupList] = useState([]);

    // API - Get group list
    const _listGroup = () => {
        setUserGroupLoader(true);

        let is_post = true;
        let url = 'user/user-groups';
        let request = {
            "page_num": 1,
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                let updated_list = response.data.data.map(data => ({
                    value: data.id,
                    label: data.name
                }))
                setGroupList(updated_list);
            } else {
                setGroupList([]);
            }
            setUserGroupLoader(false);
        })
    };


    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={() => navigate("/push-notification")}>Push Notifications</span> / <span className='e-font-weight-600'>Create Notification</span>
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 padding-32px-lr padding-32px-top padding-68px-bottom'>
                        <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Create notification
                        </h4>

                        <div className='row'>
                            <div className='col-9'>
                                <div className='row'>
                                    <div ref={el => inputRef.current.notificationTitleName = el} className='col-12 mb-4'>
                                        {/* investment name */}
                                        <CustomTextInput label="Notification title"
                                            placeholder="Enter notification title"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={notificationTitleName}
                                            error={notificationTitleNameError}
                                            className="w-100 "
                                            inputType={2}
                                            handleChange={(e) => setNotificationTitleName(e)} />
                                    </div>


                                    <div ref={el => inputRef.current.notificationContent = el} className='col-12 mb-4'>
                                        {/* investment content */}
                                        <CustomTextArea label="Notification content"
                                            placeholder="Enter content"
                                            type="text"
                                            onFocus={true}
                                            value={notificationContent}
                                            error={notificationContentError}
                                            required={true}
                                            className="w-100"
                                            borderStyle="e-border-0-5px-arsenic"
                                            handleChange={(e) => setNotificationContent(e)} />
                                    </div>


                                    <div ref={el => inputRef.current.selectedOption = el} className='col-6 mb-4'>
                                        <CustomSelectBox title='Target users'
                                            placeholder='Select target users'
                                            controlWidth='w-100'
                                            required={true}
                                            height='3rem'
                                            options={groupList}
                                            loader={userGroupLoader}
                                            isSearchable={true}
                                            borderColor={`0.031rem solid ${color.arsenic}`}
                                            value={selectedOption}
                                            onChange={(e) => setSelectedOption(e)}
                                            error={selectedOptionError} />
                                    </div>

                                    <div className='col-4 my-auto'>
                                        <TextButton name="Create user groups"
                                            add={true}
                                            onClick={_handleCreateGroup} />
                                    </div>


                                    <div ref={el => inputRef.current.selectedRedirectionLink = el} className='col-6 mb-4'>
                                        <CustomSelectBox title='Add redirection link'
                                            placeholder='Select redirection link'
                                            controlWidth='w-100'
                                            required={true}
                                            height='3rem'
                                            options={linkOptions}
                                            loader={linkOptionLoader}
                                            isSearchable={true}
                                            borderColor={`0.031rem solid ${color.arsenic}`}
                                            value={selectedRedirectionLink}
                                            onChange={(e) => setSelectedRedirectionLink(e)}
                                            error={selectedRedirectionLinkError} />
                                    </div>

                                    <div ref={el => inputRef.current.file = el} className='col-12 w-100'>
                                        <FileSelector
                                            title='Upload banner image'
                                            required={false}
                                            type={1}
                                            loader={fileLoader}
                                            fileType={FILE_TYPES}
                                            error={selectedFileError}
                                            value={file}
                                            handleChange={_handleChange}
                                            handleClose={() => _handleClose(1)} />
                                    </div>


                                    <div ref={el => inputRef.current.logo = el} className='col-3 '>
                                        <FileSelector className='padding-32px-bottom'
                                            title='Upload logo image'
                                            required={false}
                                            type={2}
                                            loader={logoLoader}
                                            error={logoError}
                                            fileType={FILE_TYPES}
                                            value={logo}
                                            handleChange={_handleChangeLogo}
                                            handleClose={() => _handleClose(2)} />
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <div className='d-flex gap-24px'>
                                            <SecondaryButton name='Cancel '
                                                paddingBlock='padding-12px-tb padding-52px-lr'
                                                onClick={_handleCancel} />
                                            <PrimaryButton name='Send notification'
                                                paddingBlock='padding-12px-tb padding-22px-lr'
                                                onClick={_handleNotification} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Create push notification modal */}
            {
                pushNotificationModal === true &&
                <PreviewModal type={1}
                    status={sendStatus}
                    button={true}
                    handleSend={() => _sendNotification()}
                    data={{ title: notificationTitleName, description: notificationContent, image: logo, banner_image: file }}
                    handleClose={() => {
                        setTimeout(() => {
                            setPushNotificationModal(false);
                            setSendStatus(false);
                        }, 200);
                    }} />
            }

            {createGroupModal === true &&
                <CreateUserGroup groupType={1}
                    handleClose={() => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                        }, 200);
                    }}
                    handleContinue={_handleContinue}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                            setCreateGroupSuccess(true);
                        }, 200);
                    }}
                />
            }

            {createGroupSuccess === true &&
                <SuccessModal title="Success!"
                    description="Group created successfully. Customers have been added to the group."
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCreateGroupSuccess(false);
                        }, 200);
                        _listGroup();

                        // navigate("/customers", {
                        //     state: {
                        //         tab_index: 2,
                        //         type: 'user_group'
                        //     }
                        // });
                    }} />
            }
        </Fragment >
    )
}

export default CreatePushNotification;
